import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  today1rno4frfjp5oe as today,
  nowLocal2mdv5rmil2cf2 as nowLocal,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import {
  plus1oi9f9vif99u2 as plus,
  minushnjyym3nfk5o as minus,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconButton2nzpucy7a6ixd as iconButton,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  text189ciz0cnr32o as text,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { addChildDialog3l2i2kmoga92p as addChildDialog } from '../children/childComponents.mjs';
import { ChildDetailPage3f2al5z4lb3ic as ChildDetailPage } from '../children/ChildDetailPage.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  plus310ted5e4i90h as plus_0,
  toSet2orjxp16sotqu as toSet,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import {
  FamilyEmployerAuthorizationz43b3id5q687 as FamilyEmployerAuthorization,
  ID39tz9k5ges9xc as ID,
  IDjecfjjw6mot9 as ID_0,
  Child1dmbiwhmddqyq as Child,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  CareProvider2qcawrqluyllr as CareProvider,
  ID1m87d1hextx54 as ID_1,
  CareLocation1v3u5wduz023s as CareLocation,
  ID1z61wlmtvxrjn as ID_2,
  Employer27b20p5x27kte as Employer,
  IDqqik72jjbpsn as ID_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  get_notNull2od35hy6ssmdh as get_notNull,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_activeRange2dh4qyh6z7x7z as get_activeRange,
  get_endInclusive3dsvnewm08bor as get_endInclusive,
  get_family1otacd6yt55oz as get_family,
  get_familyraw6f29ztw22 as get_family_0,
  get_activeRangedsifhrs4gcfc as get_activeRange_0,
  get_start30tbw38mnjak0 as get_start,
  get_endInclusive2wh7ub8763o5h as get_endInclusive_0,
  get__id1301miildb0kq as get__id,
  get__id2p9nbcwbj0zlw as get__id_0,
  get_family2au8kxs7mi7t5 as get_family_1,
  get__id1hi7gtah39onn as get__id_1,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draft3goc8q7vggbic as Draft } from '../../extensions/Draft.ext.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  eq353yrgcpovoi1 as eq,
  lte2qmhlnwrclg8p as lte,
  gte1zw995v5ulf70 as gte,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  and3dbt2f202um49 as and,
  or1uh2qn0k1rz6c as or,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import {
  familyDetails18tkj8l8txyir as familyDetails,
  familyForm1exz237lcn7kd as familyForm,
} from './familyComponents.mjs';
import { styledHeaderwng1nfqibdig as styledHeader } from '../../theme/semantics.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tablezpetcq9vbay1 as table,
  table1wgqnzrzsmc0y as table_0,
} from '../components/table.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  DayTotalsPage3tkd9ei9dl3us as DayTotalsPage,
  DayGrouping_Location_getInstancedo19cuuiy558 as DayGrouping_Location_getInstance,
} from '../reports/DayTotalsPage.mjs';
import { ReportFiltersigb451dg4asm as ReportFilters } from '../reports/ReportFilters.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from '../reports/SingleDaysPage.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function addAuthorizationDialog($this, $receiver) {
  var employer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
  var start = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(today());
  var end = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(minus(plus(today(), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(1)), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1)));
  dialog($receiver, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h2(element, 'Add employer authorization');
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$('Employer');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_1 = themed(element_0, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Select())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    var tmp = remember(VOID, VOID, VOID, VOID, FamilyDetailPage$addAuthorizationDialog$lambda$lambda);
    element_1.bind_64a41i_k$(employer, tmp, FamilyDetailPage$addAuthorizationDialog$lambda$lambda_0);
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$('Start');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_2 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (LocalDateField())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_2.willAddChild_hz2iwc_k$(element_3);
    element_3.bind_gesskf_k$(element_3.content_1, start);
    element_3.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element.willAddChild_hz2iwc_k$(element_4);
    element_4.set_content_lzqutq_k$('End');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_3 = themed(element_4, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (LocalDateField())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_3.willAddChild_hz2iwc_k$(element_5);
    element_5.bind_gesskf_k$(element_5.content_1, end);
    element_5.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_5);
    element_4.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    element.willAddChild_hz2iwc_k$(element_6);
    element_6.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element.willAddChild_hz2iwc_k$(element_7);
    element_7.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(element_7, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    this_4.willAddChild_hz2iwc_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (TextView())(element_8.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    element_8.willAddChild_hz2iwc_k$(element_9);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_9);
    var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_9));
    element_9.invoke_bnq13k_k$(tmp_2, FamilyDetailPage$addAuthorizationDialog$lambda$lambda_1);
    element_9.onStartup_vrxh3i_k$();
    element_8.addChild_2qpft2_k$(element_9);
    onClick(element_8, VOID, VOID, VOID, FamilyDetailPage$addAuthorizationDialog$lambda$slambda(close));
    element_8.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_5 = weight(element_7, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_10 = new (Space())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_10);
    this_5.willAddChild_hz2iwc_k$(element_10);
    element_10.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_10);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_6 = themed(element_7, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_7 = themed(this_6, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_11 = new (Button())(this_7.get_context_h02k06_k$());
    ensureOutermostElement(element_11);
    this_7.willAddChild_hz2iwc_k$(element_11);
    text(element_11, 'Add authorization');
    var tmp_3 = KMutableProperty0();
    var tmp_4 = Button$_get_enabled_$ref_61t7nx(element_11);
    var tmp_5 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(element_11));
    element_11.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
      var tmp;
      if (!($this$invoke.invoke_r7m7el_k$(employer) == null) && !($this$invoke.invoke_r7m7el_k$(start) == null)) {
        // Inline function 'kotlin.let' call
        var it = $this$invoke.invoke_r7m7el_k$(end);
        tmp = (!(it == null) && it.compareTo_e7gwgq_k$(ensureNotNull($this$invoke.invoke_r7m7el_k$(start))) >= 0);
      } else {
        tmp = false;
      }
      return tmp;
    });
    element_11.set_action_2ds022_k$(Action('Add authorization', VOID, VOID, VOID, VOID, VOID, FamilyDetailPage$addAuthorizationDialog$lambda$slambda_0($this, employer, start, end, close)));
    element_11.onStartup_vrxh3i_k$();
    this_7.addChild_2qpft2_k$(element_11);
    element_7.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_7);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function changeAuthorizationEndDialog($this, $receiver, authorization) {
  var end = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(authorization.activeRange_1.endInclusive_1);
  dialog($receiver, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h2(element, 'Change authorization end date');
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$('End');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_1 = themed(element_0, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (LocalDateField())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    element_1.bind_gesskf_k$(element_1.content_1, end);
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    subtext(element, 'Placements under this authorization that run past the new end date will end on it.');
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    element.willAddChild_hz2iwc_k$(element_3);
    element_3.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_2 = themed(element_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (Button())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    this_2.willAddChild_hz2iwc_k$(element_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (TextView())(element_4.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    element_4.willAddChild_hz2iwc_k$(element_5);
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_5);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_5));
    element_5.invoke_bnq13k_k$(tmp_1, FamilyDetailPage$changeAuthorizationEndDialog$lambda$lambda);
    element_5.onStartup_vrxh3i_k$();
    element_4.addChild_2qpft2_k$(element_5);
    onClick(element_4, VOID, VOID, VOID, FamilyDetailPage$changeAuthorizationEndDialog$lambda$slambda(close));
    element_4.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_4);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_3 = weight(element_3, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Space())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_3.willAddChild_hz2iwc_k$(element_6);
    element_6.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_4 = themed(element_3, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_5 = themed(this_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (Button())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    this_5.willAddChild_hz2iwc_k$(element_7);
    text(element_7, 'Save');
    var tmp_2 = KMutableProperty0();
    var tmp_3 = Button$_get_enabled_$ref_61t7nx(element_7);
    var tmp_4 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(element_7));
    element_7.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
      // Inline function 'kotlin.let' call
      var it = $this$invoke.invoke_r7m7el_k$(end);
      return !(it == null) && it.compareTo_e7gwgq_k$(authorization.activeRange_1.start_1) >= 0;
    });
    element_7.set_action_2ds022_k$(Action('Change end date', VOID, VOID, VOID, VOID, VOID, FamilyDetailPage$changeAuthorizationEndDialog$lambda$slambda_0(authorization, end, close)));
    element_7.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_7);
    element_3.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_3);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, FamilyDetailPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, FamilyDetailPage$actionBar$slambda($this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, FamilyDetailPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Save family', VOID, VOID, VOID, VOID, VOID, FamilyDetailPage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function FamilyDetailPage$family$lambda($this$Draft) {
  return $this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$();
}
function FamilyDetailPage$authorizations$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.activeRange_1.start_1;
  var tmp$ret$2 = a.activeRange_1.start_1;
  return compareValues(tmp, tmp$ret$2);
}
function FamilyDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyDetailsSectionTitle_mepryw_k$();
}
function FamilyDetailPage$render$lambda_0($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyEditIconDescription_ebeqi4_k$();
}
function FamilyDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function FamilyDetailPage$render$lambda_1($this$styledHeader) {
  return 'Employer authorizations';
}
function FamilyDetailPage$render$lambda_2($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function FamilyDetailPage$render$lambda_3($this$addButton) {
  return 'Add authorization';
}
function FamilyDetailPage$render$lambda$slambda_0(this$0, $this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    addAuthorizationDialog(this$0, $this_addButton.get_context_h02k06_k$());
    return Unit_instance;
  }), 1);
}
function FamilyDetailPage$render$lambda_4($this$table, it) {
  return $this$table;
}
function FamilyDetailPage$render$lambda_5($this$text) {
  return 'Employer';
}
function FamilyDetailPage$render$lambda_6($this$text) {
  return 'Start';
}
function FamilyDetailPage$render$lambda_7($this$text, it) {
  return renderToString(it.activeRange_1.start_1, RenderSize_Abbreviation_getInstance());
}
function FamilyDetailPage$render$lambda_8($this$text) {
  return 'End';
}
function FamilyDetailPage$render$lambda_9($this$text, it) {
  return renderToString(it.activeRange_1.endInclusive_1, RenderSize_Abbreviation_getInstance());
}
function FamilyDetailPage$render$lambda_10($this$text) {
  return 'Status';
}
function FamilyDetailPage$render$lambda_11($this$text, it) {
  return today().compareTo_e7gwgq_k$(it.activeRange_1.start_1) < 0 ? 'Upcoming' : today().compareTo_e7gwgq_k$(it.activeRange_1.endInclusive_1) > 0 ? 'Expired' : 'Active';
}
function FamilyDetailPage$render$lambda_12($this$custom) {
  return '';
}
function FamilyDetailPage$render$lambda$lambda($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function FamilyDetailPage$render$lambda$lambda_0($this$iconButton) {
  return 'Change end date';
}
function FamilyDetailPage$render$lambda$lambda$slambda(this$0, $this_iconButton, $authorization) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $this_iconButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $authorization;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    changeAuthorizationEndDialog(this$0, tmp, tmp$ret$0);
    return Unit_instance;
  }), 1);
}
function FamilyDetailPage$render$lambda_13($this$styledHeader) {
  return 'Reports';
}
function FamilyDetailPage$render$lambda_14($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyChildrenSectionTitle_2sss81_k$();
}
function FamilyDetailPage$render$lambda_15($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function FamilyDetailPage$render$lambda_16($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddChildButton_udkhcq_k$();
}
function FamilyDetailPage$render$lambda$slambda$slambda($this_addButton) {
  return constructCallableReference((child, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    yield* (yield* await_0(this_0, $completion)).get_children_4cwbp4_k$().add_co22jy_k$(child, $completion);
    var tmp = $this_addButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    toast(tmp, tmp$ret$1.get_childAddedToast_qv5dui_k$());
    return Unit_instance;
  }), 1);
}
function FamilyDetailPage$render$lambda$slambda_1(this$0, $this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.family_1;
    var tmp_0 = (yield* await_0(this_0, $completion))._id_1;
    addChildDialog(this$0, tmp, tmp_0, FamilyDetailPage$render$lambda$slambda$slambda($this_addButton));
    return Unit_instance;
  }), 1);
}
function FamilyDetailPage$render$lambda_17(it) {
  return new (ChildDetailPage())(it._id_1);
}
function FamilyDetailPage$render$lambda_18($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyNameColumnLabel_yh58ca_k$();
}
function FamilyDetailPage$render$lambda_19($this$text, it) {
  return it.get_fullName_9skygt_k$();
}
function FamilyDetailPage$render$lambda_20($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyBirthdateAgeColumnLabel_djfnz5_k$();
}
function FamilyDetailPage$render$lambda_21($this$text, it) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).childBirthdateWithAge_961sp2_k$(renderToString(it.birthDate_1, RenderSize_Abbreviation_getInstance()), it.get_ageInMonths_kafbji_k$());
}
function FamilyDetailPage$render$lambda_22($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyActivePlacementColumnLabel_repll8_k$();
}
function FamilyDetailPage$render$lambda_23($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function FamilyDetailPage$addAuthorizationDialog$lambda$lambda($this$remember) {
  return plus_0(listOf(null), $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().list$default_sjz00l_k$(new (Query())())));
}
function FamilyDetailPage$addAuthorizationDialog$lambda$lambda_0(it) {
  var tmp1_elvis_lhs = it == null ? null : it.name_1;
  return tmp1_elvis_lhs == null ? 'Choose an employer' : tmp1_elvis_lhs;
}
function FamilyDetailPage$addAuthorizationDialog$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function FamilyDetailPage$addAuthorizationDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function FamilyDetailPage$addAuthorizationDialog$lambda$slambda_0(this$0, $employer, $start, $end, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_familyEmployerAuthorizations_srfp8e_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $employer;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var tmp_0 = ensureNotNull(tmp$ret$1)._id_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $start;
    var tmp$ret$2 = yield* await_1(this_2, $completion);
    var tmp_1 = ensureNotNull(tmp$ret$2);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $end;
    var tmp$ret$3 = yield* await_1(this_3, $completion);
    yield* tmp.add_co22jy_k$(new (FamilyEmployerAuthorization())(VOID, this$0.id_1, tmp_0, new (ClosedLocalDateRange())(tmp_1, ensureNotNull(tmp$ret$3))), $completion);
    $close();
    return Unit_instance;
  }), 1);
}
function FamilyDetailPage$changeAuthorizationEndDialog$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function FamilyDetailPage$changeAuthorizationEndDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function FamilyDetailPage$changeAuthorizationEndDialog$lambda$slambda_0($authorization, $end, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var tmp = session.get_familyEmployerAuthorizations_srfp8e_k$().get_6ueaa7_k$(new (ID())($authorization._id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$5);
    var tmp_1 = get_endInclusive(get_activeRange(it));
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $end;
    var tmp$ret$7 = yield* await_1(this_2, $completion);
    this_1.assign_vtsfu6_k$(tmp_1, ensureNotNull(tmp$ret$7));
    var tmp$ret$1 = this_1.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$1, $completion);
    yield* session.get_childrenPlacement_hazabn_k$().totallyInvalidate_d4stw5_k$($completion);
    $close();
    return Unit_instance;
  }), 1);
}
function FamilyDetailPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function FamilyDetailPage$actionBar$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.family_1.cancel_2l89ey_k$();
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    return Unit_instance;
  }), 0);
}
function FamilyDetailPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familySaveFamilyButton_40ppb4_k$();
}
function FamilyDetailPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.family_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.showSecondParent_1;
    if (!(yield* await_0(this_1, $completion))) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = this$0.family_1;
      var tmp$ret$3 = yield* await_0(this_2, $completion);
      tmp_0 = yield* this$0.family_1.set_revjhg_k$(tmp$ret$3.copy$default_8deers_k$(VOID, VOID, VOID, null), $completion);
    }
    yield* this$0.family_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_1 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_strings(AppState_getInstance());
    var tmp$ret$4 = yield* await_1(this_3, $completion);
    toast(tmp_1, tmp$ret$4.get_familySavedToast_l5bkyb_k$());
    return Unit_instance;
  }), 1);
}
var FamilyDetailPageClass;
function FamilyDetailPage() {
  if (FamilyDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.family_1 = validated(Draft(new (ID_0())(this.id_1), FamilyDetailPage$family$lambda));
        var tmp_0 = this;
        tmp_0.showSecondParent_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => !($this$mutableRemember.invoke_r7m7el_k$(this.family_1).secondaryParent_1 == null));
        var tmp_1 = this;
        tmp_1.children_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_children_4cwbp4_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Child()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$3);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Child()), arrayOf([]), false));
          var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$7);
          var tmp$ret$4 = eq(get_family(it), new (ID_0())(this.id_1));
          var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
        });
        var tmp_2 = this;
        tmp_2.placements_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var now = nowLocal().get_date_wokkxj_k$();
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$13 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$13);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$14 = and(and(eq(get_family_0(it), new (ID_0())(this.id_1)), lte(get_start(get_activeRange_0(it)), now)), or(eq(get_endInclusive_0(get_activeRange_0(it)), null), gte(get_notNull(get_endInclusive_0(get_activeRange_0(it))), now)));
          var tmp$ret$10 = new (Query())(tmp$ret$14, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$10));
        });
        var tmp_3 = this;
        tmp_3.providers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$23 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$23);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$27);
          var tmp_2 = get__id(it);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.placements_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$32 = new (ID_1())(item.provider_1);
            destination.add_utx5q5_k$(tmp$ret$32);
          }
          var tmp$ret$24 = xDataClassPathInsideSet(tmp_2, toSet(destination));
          var tmp$ret$20 = new (Query())(tmp$ret$24, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$20));
        });
        var tmp_4 = this;
        tmp_4.locations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$36 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$36);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$40 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$40);
          var tmp_2 = get__id_0(it);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.placements_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$45 = new (ID_2())(item.location_1);
            destination.add_utx5q5_k$(tmp$ret$45);
          }
          var tmp$ret$37 = xDataClassPathInsideSet(tmp_2, toSet(destination));
          var tmp$ret$33 = new (Query())(tmp$ret$37, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$33));
        });
        var tmp_5 = this;
        tmp_5.authorizations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyEmployerAuthorizations_srfp8e_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$49 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$49);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(FamilyEmployerAuthorization()), arrayOf([]), false));
          var tmp$ret$53 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$53);
          var tmp$ret$50 = eq(get_family_1(it), new (ID_0())(this.id_1));
          var tmp$ret$46 = new (Query())(tmp$ret$50, orderBy, 0, 100);
          // Inline function 'kotlin.collections.sortedByDescending' call
          var this_0 = $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$46));
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp_2 = FamilyDetailPage$authorizations$lambda$lambda;
          var tmp$ret$57 = new (sam$kotlin_Comparator$0())(tmp_2);
          return sortedWith(this_0, tmp$ret$57);
        });
        var tmp_6 = this;
        tmp_6.authorizingEmployers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$61 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          new (DataClassPathSelf())(tmp$ret$61);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
          var tmp$ret$65 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$65);
          var tmp_2 = get__id_1(it);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.authorizations_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$70 = new (ID_3())(item.employer_1);
            destination.add_utx5q5_k$(tmp$ret$70);
          }
          var tmp$ret$62 = xDataClassPathInsideSet(tmp_2, toSet(destination));
          var tmp$ret$58 = new (Query())(tmp$ret$62, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$58));
        });
        this.editMode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).familyDetailTitle_gwlhpl_k$($this$remember.invoke_r7m7el_k$(this.family_1).get_familyName_6ytaaw_k$()));
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.family_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).familyDetailTitle_gwlhpl_k$($this$invoke.invoke_r7m7el_k$(this.family_1).get_familyName_6ytaaw_k$()) + ' - ' + $this$invoke.invoke_r7m7el_k$(this.family_1).shortId_1);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_5 = themed(element_2, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_centered(element_4);
        var tmp$ret$29 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_7 = get_bold(tmp$ret$29);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_4, FamilyDetailPage$render$lambda);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        var tmp_5 = get_centered(element_4);
        var tmp_6 = shownWhen(tmp_5, false, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.let' call
          var it = $this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull());
          return $this$shownWhen.invoke_r7m7el_k$(it.isAdmin_1) || $this$shownWhen.invoke_r7m7el_k$(it.managedFamilies_1).contains_aljjnj_k$(new (ID_0())(this.id_1));
        });
        var tmp_7 = get_edit(Companion_getInstance_0());
        var tmp_8 = FamilyDetailPage$render$lambda_0;
        iconButton(tmp_6, tmp_7, tmp_8, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, FamilyDetailPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        familyDetails(element_3, this.family_1, true);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Space())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_2.willAddChild_hz2iwc_k$(element_6);
        element_6.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_2.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_8 = get_atBottomStart(element_7);
        var tmp_9 = weight(this_8, 1.0);
        styledHeader(tmp_9, FamilyDetailPage$render$lambda_1);
        var tmp_10 = get_centered(element_7);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_9 = shownWhen(tmp_10, false, VOID, FamilyDetailPage$render$lambda_2);
        var tmp_11 = themed(this_9, ImportantSemantic_getInstance());
        var tmp_12 = FamilyDetailPage$render$lambda_3;
        addButton(tmp_11, tmp_12, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add authorization', VOID, VOID, VOID, VOID, VOID, FamilyDetailPage$render$lambda$slambda_0(this, $this$addButton)));
          return Unit_instance;
        });
        element_7.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_7);
        var tmp_13 = FamilyDetailPage$render$lambda_4;
        var tmp_14 = Companion_instance_0;
        var tmp_15 = FamilyDetailPage$render$lambda_5;
        var tmp_16 = tmp_14.text$default_gwb2zv_k$(tmp_15, VOID, ($this$text, authorization) => {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this$text.invoke_r7m7el_k$(this.authorizingEmployers_1);
          var tmp$ret$45;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (equals(element._id_1, authorization.employer_1)) {
                tmp$ret$45 = element;
                break $l$block;
              }
            }
            tmp$ret$45 = null;
          }
          var tmp0_safe_receiver = tmp$ret$45;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        var tmp_17 = Companion_instance_0;
        var tmp_18 = FamilyDetailPage$render$lambda_6;
        var tmp_19 = tmp_17.text$default_gwb2zv_k$(tmp_18, VOID, FamilyDetailPage$render$lambda_7);
        var tmp_20 = Companion_instance_0;
        var tmp_21 = FamilyDetailPage$render$lambda_8;
        var tmp_22 = tmp_20.text$default_gwb2zv_k$(tmp_21, VOID, FamilyDetailPage$render$lambda_9);
        var tmp_23 = Companion_instance_0;
        var tmp_24 = FamilyDetailPage$render$lambda_10;
        var tmp_25 = tmp_23.text$default_gwb2zv_k$(tmp_24, VOID, FamilyDetailPage$render$lambda_11);
        var tmp_26 = Companion_instance_0;
        var tmp_27 = FamilyDetailPage$render$lambda_12;
        table(element_2, this.authorizations_1, tmp_13, [tmp_16, tmp_19, tmp_22, tmp_25, tmp_26.custom_k0krgj_k$(tmp_27, 0.5, ($this$custom, authorization) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$custom.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var tmp = get_centered(element);
          var tmp_0 = shownWhen(tmp, false, VOID, FamilyDetailPage$render$lambda$lambda);
          var tmp_1 = get_edit(Companion_getInstance_0());
          var tmp_2 = FamilyDetailPage$render$lambda$lambda_0;
          iconButton(tmp_0, tmp_1, tmp_2, ($this$iconButton) => {
            $this$iconButton.set_action_2ds022_k$(Action('Change end date', VOID, VOID, VOID, VOID, VOID, FamilyDetailPage$render$lambda$lambda$slambda(this, $this$iconButton, authorization)));
            return Unit_instance;
          });
          element.onStartup_vrxh3i_k$();
          $this$custom.addChild_2qpft2_k$(element);
          return Unit_instance;
        })]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (Space())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element_2.willAddChild_hz2iwc_k$(element_8);
        element_8.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_8);
        styledHeader(element_2, FamilyDetailPage$render$lambda_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_2.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_10 = themed(element_9, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (Link())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_10.willAddChild_hz2iwc_k$(element_10);
        text(element_10, 'Benefit by location');
        var tmp_28 = KMutableProperty0();
        var tmp_29 = Link$_get_to_$ref_jq7esp(element_10);
        var tmp_30 = getPropertyCallableRef('to', 0, tmp_28, tmp_29, Link$_set_to_$ref_i9gu5x(element_10));
        element_10.invoke_bnq13k_k$(tmp_30, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (DayTotalsPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, setOf(new (ID_0())(this.id_1))));
          this_0.groupBy_1.set_value_v1vabv_k$(DayGrouping_Location_getInstance());
          return this_0;
        });
        element_10.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_11 = themed(element_9, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (Link())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_11.willAddChild_hz2iwc_k$(element_11);
        text(element_11, 'Days in care');
        var tmp_31 = KMutableProperty0();
        var tmp_32 = Link$_get_to_$ref_jq7esp(element_11);
        var tmp_33 = getPropertyCallableRef('to', 0, tmp_31, tmp_32, Link$_set_to_$ref_i9gu5x(element_11));
        element_11.invoke_bnq13k_k$(tmp_33, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (SingleDaysPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, VOID, setOf(new (ID_0())(this.id_1))));
          return this_0;
        });
        element_11.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_11);
        element_9.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Space())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element_2.willAddChild_hz2iwc_k$(element_12);
        element_12.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        element_2.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_12 = get_atBottomStart(element_13);
        var tmp_34 = weight(this_12, 1.0);
        styledHeader(tmp_34, FamilyDetailPage$render$lambda_14);
        var tmp_35 = get_centered(element_13);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_13 = shownWhen(tmp_35, false, VOID, FamilyDetailPage$render$lambda_15);
        var tmp_36 = themed(this_13, ImportantSemantic_getInstance());
        var tmp_37 = FamilyDetailPage$render$lambda_16;
        addButton(tmp_36, tmp_37, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add child', VOID, VOID, VOID, VOID, VOID, FamilyDetailPage$render$lambda$slambda_1(this, $this$addButton)));
          return Unit_instance;
        });
        element_13.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_13);
        var tmp_38 = FamilyDetailPage$render$lambda_17;
        var tmp_39 = Companion_instance_0;
        var tmp_40 = FamilyDetailPage$render$lambda_18;
        var tmp_41 = tmp_39.text$default_gwb2zv_k$(tmp_40, VOID, FamilyDetailPage$render$lambda_19);
        var tmp_42 = Companion_instance_0;
        var tmp_43 = FamilyDetailPage$render$lambda_20;
        var tmp_44 = tmp_42.text$default_gwb2zv_k$(tmp_43, VOID, FamilyDetailPage$render$lambda_21);
        var tmp_45 = Companion_instance_0;
        var tmp_46 = FamilyDetailPage$render$lambda_22;
        table_0(element_2, this.children_1, tmp_38, [tmp_41, tmp_44, tmp_45.custom_k0krgj_k$(tmp_46, 2.0, ($this$custom, child) => {
          var tmp = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.invoke_r7m7el_k$(this.placements_1);
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (equals(element.child_1, $this$remember.invoke_r7m7el_k$(child)._id_1)) {
                destination.add_utx5q5_k$(element);
              }
            }
            return destination;
          });
          colOf($this$custom, tmp, VOID, VOID, VOID, ($this$colOf, placement) => {
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (TextView())($this$colOf.get_context_h02k06_k$());
            ensureOutermostElement(element);
            $this$colOf.willAddChild_hz2iwc_k$(element);
            var tmp = KMutableProperty0();
            var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
            var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
            element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
              // Inline function 'kotlin.collections.find' call
              var tmp0 = $this$invoke.invoke_r7m7el_k$(this.providers_1);
              var tmp$ret$86;
              $l$block_0: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
                while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                  var element = _iterator__ex2g4s.next_20eer_k$();
                  if (equals(element._id_1, $this$invoke.invoke_r7m7el_k$(placement).provider_1)) {
                    tmp$ret$86 = element;
                    break $l$block_0;
                  }
                }
                tmp$ret$86 = null;
              }
              var tmp0_safe_receiver = tmp$ret$86;
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
              var providerName = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
              // Inline function 'kotlin.collections.find' call
              var tmp0_0 = $this$invoke.invoke_r7m7el_k$(this.locations_1);
              var tmp$ret$89;
              $l$block_1: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
                  var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
                  if (equals(element_0._id_1, $this$invoke.invoke_r7m7el_k$(placement).location_1)) {
                    tmp$ret$89 = element_0;
                    break $l$block_1;
                  }
                }
                tmp$ret$89 = null;
              }
              var tmp2_safe_receiver = tmp$ret$89;
              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.name_1;
              var locationName = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
              var tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
              var tmp4_safe_receiver = $this$invoke.invoke_r7m7el_k$(placement).signingInfo_1;
              var signatureStatus = tmp.signatureStatusLabel_agp5cg_k$(tmp4_safe_receiver == null ? null : tmp4_safe_receiver.status_1);
              return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).familyPlacementSummary_u4ho0l_k$(providerName, locationName, signatureStatus);
            });
            element.onStartup_vrxh3i_k$();
            $this$colOf.addChild_2qpft2_k$(element);
            return Unit_instance;
          });
          return Unit_instance;
        })]);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_14.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Separator())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        element_14.willAddChild_hz2iwc_k$(element_15);
        element_15.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_15);
        actionBar(this, element_14);
        familyForm(this, element_14, this.family_1, this.showSecondParent_1);
        actionBar(this, element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (Separator())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_14.willAddChild_hz2iwc_k$(element_16);
        element_16.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_16);
        element_14.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_15 = shownWhen(element, VOID, VOID, FamilyDetailPage$render$lambda_23);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Space())(this_15.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_17);
        this_15.willAddChild_hz2iwc_k$(element_17);
        element_17.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_17);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'FamilyDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    FamilyDetailPageClass = $;
  }
  return FamilyDetailPageClass;
}
//region block: exports
export {
  FamilyDetailPage as FamilyDetailPage2yycb034kbs09,
};
//endregion

//# sourceMappingURL=FamilyDetailPage.mjs.map
